import React from 'react';
// No longer needs ThumbNavigator.css if you put the new class in index.css
import './SingleVizControls.css'; 

const SingleVizControls = ({ onHomeClick, onInfoClick, onNewTabClick, infoUrl }) => {
  return (
    // Use the new, dedicated class name here
    <div className="single-viz-controls-container">
      {/* Info Button - only shown if infoUrl exists */}
      {infoUrl && (
        <button onClick={onInfoClick} className="nav-button" title="Show Info">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="28" height="28"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>
        </button>
      )}
      {/* Home Button */}
      <button onClick={onHomeClick} className="nav-button" title="Go Home">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="28" height="28"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z" /></svg>
      </button>


    </div>
  );
};

export default SingleVizControls;